export default {
  LIST_FETCHED: 'WELCOME_MAIL_FETCHED',
  LIST_LOAD: 'WELCOME_MAIL_LOAD',
  ITEM_DETAIL: 'WELCOME_MAIL_DETAIL',
  BUTTON_LOAD: 'WELCOME_MAIL_BUTTON_LOAD',
};
